<template>
  <v-card flat width="90%" max-width="1560" class="my-10 mx-auto">
    <ValidationObserver ref="observer" v-slot="{ valid }">
      <div
        class="
          d-flex
          variantOne--text
          flex-wrap
          justify-space-between
          align-center
        "
      >
        <p class="col-12 text-h4 variantOne--text">
          <span>{{ $t("landlord.editUnit") }}</span>
        </p>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card
            flat
            class="rounded-lg pa-md-1 px-md-12 mb-12"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <v-row class="pt-7">
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-text-field
                    outlined
                    v-model="variables.nameEn"
                    class="rounded-lg"
                    :error-messages="errors"
                    :label="$t('landlord.unitNameEn')"
                    ><template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitNameEn") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-text-field
                    outlined
                    v-model="variables.nameAr"
                    :error-messages="errors"
                    class="rounded-lg"
                    :label="$t('landlord.unitNameAr')"
                    ><template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitNameAr") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                    outlined
                    :label="$t('landlord.unitType')"
                    class="rounded-lg"
                    v-model="variables.unitType"
                    item-value="_id"
                    :error-messages="errors"
                    :item-text="$vuetify.rtl ? 'nameAr' : 'nameEn'"
                    :items="unitTypes"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitType") }}
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="4" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                    outlined
                    :label="$t('landlord.selectRent')"
                    class="rounded-lg"
                    v-model="variables.rentType"
                    :error-messages="errors"
                    :disabled="true"
                    :items="['PER_DAY', 'PER_MONTH']"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.selectRent") }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ $t(`rentType.${item}`) }}
                    </template>
                    <template v-slot:item="{ item }">
                      {{ $t(`rentType.${item}`) }}
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="4" class="py-0">
                <ValidationProvider
                  :rules="{ required: true, day: /^([1-9]|[12][0-9]|3[01])$/ }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    ref="paymentCollectionDayRef"
                    outlined
                    :label="$t('landlord.paymentCollectionDay')"
                    v-model="variables.paymentCollectionDay"
                    class="rounded-lg"
                    :error-messages="errors"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.paymentCollectionDay") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        type="number"
                        outlined
                        v-model="variables.floorArea"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.areaSqm')"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.areaSqm") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                  <!-- <v-col cols="6" class="py-0">
                    <ValidationProvider
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        type="number"
                        :disabled="maxNewRooms"
                        class="rounded-lg inputphone"
                        :label="$t('landlord.numberOfunits')"
                        :error-messages="errors"
                        readonly
                        :rules="[checkIfRoomsExhausted, validateNumberOfUnits]"
                        v-model="newNumberOfUnits"
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.numberOfunits") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="6" md="6" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="variables.oldRent"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.oldRent')"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.oldRent") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="6" md="6" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="variables.rent"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.rent')"
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.rent") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="justify-space-between" align="center">
              <!-- v-if="newNumberOfUnits > parseInt(prevNumberOfUnits)" -->
              <v-col>
                <v-text-field
                  outlined
                  v-model="newRoomString"
                  readonly
                  @blur="pushToRoomsArray"
                  :hint="$t('landlord.roomHint')"
                  class="rounded-lg"
                  :placeholder="
                    maxNewRooms
                      ? $t('landlord.enteredMaxRooms')
                      : $t('landlord.addRooms')
                  "
                >
                  <!-- :readonly="maxNewRooms" -->
                  <template
                    v-slot:prepend-inner
                    v-if="prevRoomNumbers.length !== 0"
                  >
                    <v-chip-group column>
                      <v-chip
                        color="success"
                        v-for="room in prevRoomNumbers"
                        :key="room"
                      >
                        {{ room }}
                      </v-chip>
                    </v-chip-group>
                    <v-chip-group v-if="newRoomNumbers.length !== 0">
                      <v-chip
                        color="primary"
                        close
                        v-for="room in newRoomNumbers"
                        @click:close="removeRoomFromArray(room)"
                        :key="room"
                      >
                        {{ room }}
                      </v-chip>
                    </v-chip-group>
                  </template>
                  <!-- <template v-slot:append-outer  v-if="prevRoomNumbers.length !== 0">
                <v-btn
                  x-large
                  :disabled="newRoomNumbers.length === 0"
                  @click="newRoomNumbers = []"
                  text
                  color="primary">
                  Clear All
                </v-btn>
                </template> -->
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-textarea
                    clear-icon="rounded-lg"
                    height="141"
                    :label="$t('landlord.aboutPropertyEn')"
                    v-model="variables.descriptionEn"
                    :error-messages="errors"
                    outlined
                    no-resize
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.aboutPropertyEn") }}
                    </template></v-textarea
                  >
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-textarea
                    clear-icon="rounded-lg"
                    height="141"
                    v-model="variables.descriptionAr"
                    :label="$t('landlord.aboutPropertyAr')"
                    :error-messages="errors"
                    outlined
                    no-resize
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.aboutPropertyAr") }}
                    </template></v-textarea
                  >
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card>
          <v-card
            flat
            class="rounded-lg pa-md-8 px-md-12 mb-12 mt-16"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <v-row class="">
              <v-col cols="12" sm="11" md="5" lg="4" class="py-0">
                <v-row v-for="(item, index) in fecilityCount" :key="index">
                  <v-col cols="5" sm="4" md="6">
                    <span class="d-block text-caption">{{ item.title }}</span>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <v-card
                      width="200"
                      elevation="0"
                      class="
                        rounded-lg
                        card-custom-border
                        d-flex
                        justify-space-around
                      "
                    >
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="subperson(item)" class="white--text"
                          >mdi-minus</v-icon
                        >
                      </div>
                      <span class="ma-2">{{
                        item.count === null ? 0 : item.count
                      }}</span>
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="addperson(item)" class="white--text"
                          >mdi-plus</v-icon
                        >
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" sm="4" class="mt-5" md="6">
                    <span class="text-caption">{{
                      $t("landlord.parking")
                    }}</span>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-start">
                    <v-checkbox
                      v-model="variables.isParkingAvailable"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-16">
          <v-row>
            <v-col cols="12" md="6">
              <v-card
                @click="onClickImageUpload()"
                flat
                height="400px"
                class="
                  rounded-lg
                  card-custom-border
                  py-10
                  d-flex
                  justify-center
                  align-center
                "
              >
                <div>
                  <ValidationProvider
                    :rules="{
                      maxSize: 8000
                    }"
                  >
                    <v-file-input
                      v-model="imageUpload"
                      v-show="false"
                      multiple
                      accept="image/*"
                      ref="imageUpload"
                      label="File input"
                    ></v-file-input>
                    <v-img
                      class="mx-auto"
                      :src="require('@/assets/cameraUpload.png')"
                      width="50px"
                    ></v-img>
                    <p class="mt-5">
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.uploadPropertyUnitPhotos") }}
                    </p>
                    <div class="d-flex flex-column" style="gap: 5px;">
                      <v-btn
                        class="rounded-lg mx-auto white--text"
                        color="primary"
                        height="40px"
                        elevation="0"
                        width="200px"
                        >{{ $t("landlord.editPhotos") }}
                      </v-btn>
                      <span class="red--text text-caption mx-auto">
                        *{{ $t("inputRules.fileLengthWarning") }}
                      </span>
                    </div>
                  </ValidationProvider>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="">
              <v-row class="" v-if="images.length <= 4">
                <v-col
                  class="py-0"
                  :cols="6"
                  v-for="(i, index) in images.length"
                  :key="i"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      @click="removeImage(index)"
                      flat
                      height="175"
                      class="card-custom-border rounded-lg mb-12 cursor-pointer"
                    >
                      <v-img height="100%" width="100%" :src="images[index]">
                      </v-img>

                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="primary">
                          <v-icon>mdi-close</v-icon>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>

              <v-row class="" v-else>
                <v-col
                  class="py-0"
                  :cols="4"
                  v-for="(i, index) in images.length"
                  :key="i"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      @click="removeImage(index)"
                      flat
                      height="102"
                      class="card-custom-border rounded-lg mb-12 cursor-pointer"
                    >
                      <v-img height="100%" width="100%" :src="images[index]">
                      </v-img>

                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="primary">
                          <v-icon>mdi-close</v-icon>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card
            flat
            class="rounded-lg pa-md-8 px-md-12 mb-12 mt-16"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <p class="text-h6 font-weight-bold">
              {{ $t("landlord.allowedFor") }}
            </p>
            <v-row class="">
              <v-col cols="12" md="6" lg="7" class="py-0 ">
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{
                    $t("landlord.bachelorsAreWelcome")
                  }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox
                      v-model="variables.isBachelorAllowed"
                    ></v-checkbox>
                  </span>
                </div>
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{
                    $t("landlord.familiesAreWelcome")
                  }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox
                      v-model="variables.isFamillyAllowed"
                    ></v-checkbox>
                  </span>
                </div>
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{ $t("landlord.pets") }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox v-model="variables.isPetAllowed"></v-checkbox>
                  </span>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="11"
                md="6"
                lg="4"
                class="py-0"
                v-if="variables.rentType === 'PER_DAY'"
              >
                <v-row v-for="(item, index) in peopleCount" :key="index">
                  <v-col cols="5" sm="4" md="6">
                    <span class="d-block text-caption">{{ item.title }}</span>
                    <span class="d-block text--disabled text-caption"
                      >({{ item.sub }})</span
                    >
                  </v-col>
                  <v-col cols="7" md="6" class="d-flex ">
                    <v-card
                      width="200"
                      elevation="0"
                      class="
                        rounded-lg
                        card-custom-border
                        d-flex
                        justify-space-around
                      "
                    >
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="subperson(item)" class="white--text"
                          >mdi-minus</v-icon
                        >
                      </div>
                      <span class="ma-2">{{ item.count }}</span>
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="addperson(item)" class="white--text"
                          >mdi-plus</v-icon
                        >
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                elevation="0"
                :width="$vuetify.breakpoint.smAndUp ? '300px' : '100%'"
                :loading="loading"
                height="45px"
                @click="goBack()"
                class="white--text font-weight-bold rounded-lg"
                color="primary"
              >
                Back
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-right">
              <v-btn
                elevation="0"
                :width="$vuetify.breakpoint.smAndUp ? '300px' : '100%'"
                :loading="loading"
                height="45px"
                :disabled="!valid || formError"
                color="primary"
                class="rounded-lg white--text font-weight-bold"
                @click="onUpdate"
              >
                {{ $t("landlord.editUnit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-snackbar :timeout="2000" v-model="snackBar" :color="snackColor">{{
        snackText
      }}</v-snackbar>
    </ValidationObserver>
  </v-card>
</template>

<script>
import moment from "moment";
import { updateUnit } from "../../methods/update_unit";
import "@/core/methods/validation_rules";
import { compressImage } from "@/core/methods/compress_image";
export default {
  props: {
    unitId: {
      type: String,
      required: true
    },
    totalNumberOfUnitsAllowed: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      images: [],
      property: null,
      imageUpload: null,
      prevNumberOfUnits: 0,
      newNumberOfUnits: 0,
      prevRoomNumbers: [],
      newRoomNumbers: [],
      newRoomString: "",
      isValidityAlertShown: false,
      maxNewRooms: false,
      currentlyAddedRoomsCount: 0,
      successDialog: false,
      paymentCollectionDay: null,
      paymentCollectionDayMenu: false,
      rentType: null,
      variables: {
        images: [],
        property: null,
        rentType: null,
        paymentCollectionDay: null
      },
      resetVariables: {
        images: []
      },
      roomErrors: {
        minRoomError: false,
        maxRoomError: false
      },
      unitTypes: [],
      fecilityCount: [
        { title: this.$t("landlord.numberOfBedrooms"), count: 1, limit: 5 },
        { title: this.$t("landlord.numberOfBathrooms"), count: 1, limit: 5 },
        { title: this.$t("landlord.numberOfHalls"), count: 1, limit: 5 }
      ],
      peopleCount: [
        {
          title: this.$t("landlord.numberOfAdults"),
          sub: this.$t("landlord.age13orAbove"),
          count: 1,
          limit: 25
        },
        {
          title: this.$t("landlord.numberOfChildren"),
          sub: this.$t("landlord.age12"),
          count: 0,
          limit: 15
        },
        {
          title: this.$t("landlord.numberOfInfants"),
          sub: this.$t("landlord.under2"),
          count: 0,
          limit: 10
        }
      ],
      resetPeopleCount: [
        {
          title: this.$t("landlord.numberOfAdults"),
          sub: this.$t("landlord.age13orAbove"),
          count: 1,
          limit: 25
        },
        {
          title: this.$t("landlord.numberOfChildren"),
          sub: this.$t("landlord.age12"),
          count: 0,
          limit: 15
        },
        {
          title: this.$t("landlord.numberOfInfants"),
          sub: this.$t("landlord.under2"),
          count: 0,
          limit: 10
        }
      ],
      snackBar: false,
      snackColor: "",
      snackText: ""
    };
  },
  computed: {
    formError() {
      if (this.roomErrors.minRoomError) {
        return true;
      }
      if (this.roomErrors.maxRoomError) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.getUnitById();
  },
  watch: {
    newRoomNumbers() {
      const diff = this.newNumberOfUnits - this.prevNumberOfUnits;
      this.newRoomNumbers.length === diff
        ? (this.maxNewRooms = true)
        : (this.maxNewRooms = false);
    },
    newRoomString: {
      handler(roomString) {
        if (this.prevRoomNumbers.includes(roomString.split(",")[0])) {
          return null;
        } else if (!this.newRoomNumbers.includes(roomString.split(",")[0])) {
          if (roomString && roomString.includes(",")) {
            const rooms = roomString.split(",");
            this.newRoomNumbers.push(rooms[0]);
            this.newRoomString = "";
          }
        }
      },
      immediate: true
    },
    imageUpload: {
      handler(images) {
        if (images.length) {
          if (!this.variables.images.length) {
            this.images = [];
          }
          images.map(val => {
            let noOfImages = this.images.length;
            this.images[noOfImages] = URL.createObjectURL(val);
            this.variables.images[noOfImages] = val;
          });
        }
      }
    }
  },
  methods: {
    pushToRoomsArray() {
      if (this.newRoomString) {
        this.newRoomNumbers.push(this.newRoomString);
        return (this.newRoomString = "");
      }
    },
    checkIfRoomsExhausted(numberOfUnits) {
      const allowedUnitCount = this.totalNumberOfUnitsAllowed;
      const difference = numberOfUnits - this.prevNumberOfUnits;
      if (this.currentlyAddedRoomsCount + difference <= allowedUnitCount) {
        this.isRoomsDisabled = false;
        this.roomErrors.maxRoomError = false;
        return true;
      } else {
        this.isRoomsDisabled = true;
        this.roomErrors.maxRoomError = true;
        return "Total Units Should Not Exceed " + allowedUnitCount;
      }
    },
    validateNumberOfUnits(numberOfUnits) {
      if (numberOfUnits < this.prevNumberOfUnits) {
        this.roomErrors.minRoomError = true;
        return "Number Should Be Greater Than " + this.prevNumberOfUnits;
      } else {
        this.roomErrors.minRoomError = false;
        return true;
      }
    },
    removeRoomFromArray(room) {
      const newArray = [];
      this.newRoomNumbers.forEach(eachRoom => {
        if (room !== eachRoom) newArray.push(eachRoom);
      });
      this.newRoomNumbers = newArray;
    },
    formatedDate(date) {
      if (date) return moment(date).format("DD/MM/YYYY");
      else return "";
    },
    goBack() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$root.$emit("refetchUnits");
    },
    addperson(item) {
      if (item.count < item.limit) {
        item.count = item.count + 1;
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.limitReached");
      }
    },
    subperson(item) {
      if (item.count > 0) {
        item.count = item.count - 1;
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = "Atleast one needed";
      }
    },
    getUnitById() {
      this.$apollo
        .watchQuery({
          query: require("@/landlord/api/queries/get_unit_by_id.graphql"),
          variables: { id: this.unitId }
        })
        .refetch()
        .then(response => {
          this.units = response.data.getUnitById;
          this.prevNumberOfUnits = this.units.numberOfUnits;
          this.newNumberOfUnits = this.prevNumberOfUnits;
          this.prevRoomNumbers = this.units.unitDetails.map(item => {
            return item.roomNumber;
          });
          this.variables = {
            id: this.units._id,
            nameEn: this.units.nameEn,
            nameAr: this.units.nameAr,
            property: this.units.property._id,
            unitType: this.units.unitType._id,
            descriptionEn: this.units.descriptionEn,
            descriptionAr: this.units.descriptionAr,
            images: [],
            floorArea: this.units.floorArea,
            rent: this.units.rent,
            oldRent: this.units.oldRent,
            rentType: this.units.rentType,
            numberOfUnits: this.units.numberOfUnits,
            adultCount: this.units.adultCount,
            childCount: this.units.childCount,
            infantCount: this.units.infantCount,
            isBachelorAllowed: this.units.isBachelorAllowed,
            isFamillyAllowed: this.units.isFamillyAllowed,
            isPetAllowed: this.units.isPetAllowed,
            paymentCollectionDay: this.units.paymentCollectionDay,
            numberOfRooms: this.units.numberOfRooms,
            numberOfBathrooms: this.units.numberOfBathrooms,
            numberOfHalls: this.units.numberOfHalls,
            isParkingAvailable: this.units.isParkingAvailable
          };
          this.$refs.paymentCollectionDayRef.focus();
          this.$refs.paymentCollectionDayRef.blur();
          this.peopleCount[0].count = this.units.adultCount;
          this.peopleCount[1].count = this.units.childCount;
          this.peopleCount[2].count = this.units.infantCount;
          this.fecilityCount[0].count = this.units.numberOfRooms;
          this.fecilityCount[1].count = this.units.numberOfBathrooms;
          this.fecilityCount[2].count = this.units.numberOfHalls;

          this.images = [];
          this.units.images.map(image => {
            this.images.push(`${this.$store.getters.imageBaseUrl}/` + image);
          });
        });
    },
    onClickImageUpload() {
      this.$refs.imageUpload.$refs.input.click();
    },
    removeImage(index) {
      if (!this.variables.images.length) {
        this.images = [];
      } else {
        let image = this.images[index];
        this.images = this.images.filter(item => {
          return item !== image;
        });
        let img = this.variables.images[index];
        this.variables.images = this.variables.images.filter(item => {
          return item !== img;
        });
      }
    },

    async onUpdate() {
      if (
        this.newRoomNumbers.length <
        this.newNumberOfUnits - this.prevNumberOfUnits
      ) {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.roomNumbersMissing");
        return false;
      } else {
        let roomString = "";
        this.newRoomNumbers.forEach((room, index) => {
          roomString += room;
          if (index !== this.newRoomNumbers.length - 1) {
            roomString += ",";
          }
        });
        this.variables.roomNumbers = roomString;
      }
      if (this.variables.rentType === "PER_DAY") {
        if (this.peopleCount[0].count < 1) {
          this.snackBar = true;
          this.snackColor = "error";
          this.snackText = this.$t("landlord.oneAdultNeeded");
          return false;
        } else {
          this.variables.adultCount = this.peopleCount[0].count;
          this.variables.childCount = this.peopleCount[1].count;
          this.variables.infantCount = this.peopleCount[2].count;
        }
      }
      if (this.fecilityCount[0].count < 1 && this.fecilityCount[1].count < 1) {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.atleastOneRoom");
        return false;
      } else {
        this.variables.numberOfRooms = this.fecilityCount[0].count;
        this.variables.numberOfBathrooms = this.fecilityCount[1].count;
        this.variables.numberOfHalls = this.fecilityCount[2].count;
      }
      this.variables.floorArea = parseFloat(this.variables.floorArea);
      this.variables.rent = parseFloat(this.variables.rent);
      this.variables.oldRent = parseFloat(this.variables.oldRent);
      this.variables.numberOfUnits = parseInt(this.newNumberOfUnits);
      this.variables.paymentCollectionDay = parseInt(
        this.variables.paymentCollectionDay
      );
      if (!this.variables.images && !this.variables.images.length) {
        this.variables.images = null;
      } else {
        // compress images
        this.variables.images = await Promise.all(
          this.variables.images.map(async image => await compressImage(image))
        );
      }
      updateUnit(this.variables).then(response => {
        if (response.data.updateUnit) {
          if (response.data.updateUnit._id) {
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("landlord.unitUpdatedSuccessfully"),
              color: "success"
            });
            this.$root.$emit("refetchUnits");
            return this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
          }
        } else {
          this.snackBar = true;
          this.snackColor = "error";
          this.snackText = this.$t("snack.somethingWentWrong");
          return false;
        }
      });
    }
  },
  apollo: {
    getUnitTypes() {
      return {
        query: require("@/landlord/api/queries/get_unit_types.graphql"),
        variables: { limit: 0, skip: 0 },
        result({ data }) {
          this.unitTypes = data.getUnitTypes.unitTypes;
        }
      };
    }
  }
};
</script>

<style scoped>
.card-custom-border {
  border: 1px solid #d8d7d7 !important;
}

.custom-round-button {
  height: 25px;
  width: 25px;
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.custom-round-button-large {
  height: 45px;
  width: 45px;
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
</style>
<style>
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 0px;
}
.v-text-field--full-width .v-input__prepend-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 5px;
  margin-bottom: 5px;
}
.inputphone input[type="number"] {
  -moz-appearance: textfield;
}
.inputphone input::-webkit-outer-spin-button,
.inputphone input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
